<template>
  <div class="container">
    <b-row class="mt-3">
      <b-col lg="3" md="2" sm="0"></b-col>
      <b-col lg="6" md="8" sm="12">
        <b-card>
          <div>
            <h4 class="text-center">
              {{ $t("accountDetails.changePassword") }}
            </h4>
          </div>
          <label for="password" class="input-label">{{
            $t("oldPassword")
          }}</label
          ><v-text-field
            v-model="oldPassword"
            id="password"
            :placeholder="$t('enterOldPassword')"
            type="text"
            required
            outlined
            dense
          ></v-text-field>
          <label for="password" class="input-label">{{
            $t("newPassword")
          }}</label
          ><v-text-field
            v-model="newPassword"
            id="password"
            :placeholder="$t('newPassword')"
            :type="showPassword1 ? 'password' : 'text'"
            :append-icon="showPassword1 ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="togglePasswordVisibility1"
            required
            outlined
            dense
          ></v-text-field>
          <p v-if="newPassword && passwordValidationMessage" style="color: red">
            {{ passwordValidationMessage }}
          </p>
          <label for="password" class="input-label">{{
            $t("confirmNewPassword")
          }}</label>
          <v-text-field
            v-model="confirmPassword"
            id="password1"
            :placeholder="$t('confirmNewPassword')"
            :type="showPassword2 ? 'password' : 'text'"
            :append-icon="showPassword2 ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="togglePasswordVisibility2"
            class="password-field"
            required
            outlined
            dense
          ></v-text-field>
          <div class="text-center">
            <button
              class="btn btn-outline-primary mr-3 pr-3 pl-3"
              @click="$router.push('/profile')"
            >
              {{ $t("viewAddress.cancel") }}
            </button>
            <button
              @click="updateProfile"
              class="btn btn-primary editSaveBtn ml-3 pr-4 pl-4"
            >
              {{ $t("viewAddress.save") }}
            </button>
          </div></b-card
        >
      </b-col>
      <b-col lg="3" md="2" sm="0"></b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPassword1: false,
      showPassword2: false,
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      first: "",
    };
  },
  computed: {
    passwordMatch() {
      return this.newPassword === this.confirmPassword;
    },
    passwordValidationMessage() {
      const password = this.newPassword || "";
      const rules = [];

      if (password.length < 8) {
        rules.push("at least 8 characters");
      }
      if (!/[a-z]/.test(password)) {
        rules.push("1 lowercase letter");
      }
      if (!/[A-Z]/.test(password)) {
        rules.push("1 uppercase letter");
      }
      if (!/[^a-zA-Z0-9]/.test(password)) {
        rules.push("1 special character");
      }

      return rules.length ? `Password must contain ${rules.join(", ")}.` : "";
    },
    isStrongPassword() {
      return this.passwordValidationMessage === "";
    },
  },
  methods: {
    togglePasswordVisibility1() {
      this.showPassword1 = !this.showPassword1;
    },
    togglePasswordVisibility2() {
      this.showPassword2 = !this.showPassword2;
    },
    async updateProfile() {
      if (!this.oldPassword || !this.newPassword || !this.confirmPassword) {
        this.$swal({
          title: this.$t("swal.error"),
          text: this.$t("swal.missingFields"),
          icon: "error",
        });
        return;
      }

      if (!this.passwordMatch) {
        this.$swal({
          title: this.$t("swal.error"),
          text: this.$t("swal.passwordNotMatch"),
          icon: "error",
        });
        return;
      }

      if (!this.isStrongPassword) {
        this.$swal({
          title: this.$t("swal.error"),
          text: this.passwordValidationMessage,
          icon: "error",
        });
        return;
      }

      const payload = {
        currentPassword: this.oldPassword,
        newPassword: this.newPassword,
      };

      try {
        await this.$store.dispatch("profile/updatePassword", payload);
        this.$swal({
          text: this.$t("swal.passwordUpdated"),
          type: "success",
          title: this.$t("swal.title"),
          timer: 1100,
        });
        this.$router.push("/profile");
      } catch (error) {
        this.$swal({
          title: this.$t("swal.error"),
          text: error.message || this.$t("swal.failedPassword"),
          icon: "error",
        });
      }
    },
  },
};
</script>

<style scoped>
/* .password-field >>> .v-input__append-inner {
  cursor: pointer;
}
.password-field >>> .v-icon {
  background: none !important;
  padding: 0 !important;
  margin-right: 4px;
  color: #666;
} */

::v-deep .v-icon.v-icon {
  background: none !important;
  border: none !important;
  box-shadow: none !important;
}
</style>
